import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(
  nominativo: string,
  indirizzo: number,
  telefono: number
) {
  return { nominativo, indirizzo, telefono};
}

const rows = [
  createData('Mario Rossi', 159, 6.0),
  createData('Giuseppe Bianchi', 237, 9.0),
  createData('Alessio Russo', 262, 16.0),
  createData('Giovanni Rossi', 305, 3.7),
  createData('Federico Grande', 356, 16.0),
];

type Props = {};

const AnagraficaTrasportiPage = (props: Props) => {
  return (
    <div>
      <h2>Anagrafica Trasporti</h2>
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Nominativo</TableCell>
            <TableCell align="right">Indirizzo</TableCell>
            <TableCell align="right">Numero Tel.</TableCell>
            <TableCell align="right">Azioni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.nominativo}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.nominativo}
              </TableCell>
              <TableCell align="right">{row.indirizzo}</TableCell>
              <TableCell align="right">{row.telefono}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>


    </div>
  );
};

export default AnagraficaTrasportiPage;